import {IErrorClassifierErrorKey, IErrorClassifierErrorKeyForm} from "../../../../../store/errorClassifier/types";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {ErrorClassifierService} from "../../../../../services/error_classifier.service";

export function useCreateErrorKey() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: IErrorClassifierErrorKeyForm) => ErrorClassifierService.createErrorKey(data),

        onMutate: async (newData) => {
            await queryClient.cancelQueries({queryKey: ["keyErrorClassifierErrorKeys"]});

            const previousKeys = queryClient.getQueryData<IErrorClassifierErrorKey[]>(["keyErrorClassifierErrorKeys"]);

            const tempId = Math.random() * -1; // negative ID for temporary keys

            const optimisticKey: IErrorClassifierErrorKey = {id: tempId, ...newData};

            queryClient.setQueryData<IErrorClassifierErrorKey[]>(["keyErrorClassifierErrorKeys"], (old) =>
                old ? [...old, optimisticKey] : [optimisticKey]
            );

            return {previousKeys, tempId};
        },

        onError: (err, newData, context) => {
            if (context?.previousKeys) {
                queryClient.setQueryData(["keyErrorClassifierErrorKeys"], context.previousKeys);
            }
        },

        onSuccess: (savedItem, newData, context) => {
            queryClient.setQueryData<IErrorClassifierErrorKey[]>(["keyErrorClassifierErrorKeys"], (old) =>
                old?.map((key) => (key.id === context?.tempId ? savedItem : key)) ?? [savedItem]
            );
        },
    });
}
